<template>
    <form :action="action" class="registration-form" method="POST" v-if="form">
        <input type="hidden" name="_token" :value="csrkToken" />

        <md-card class="profil-form">
            <md-card-header>
                <h2 class="md-title md-title-dark page-sub-title" v-html="title" />
            </md-card-header>

            <md-card-content>
                <transition name="slide-y-top">
                    <div>
                        <div v-if="!hideEntityType" :class="{ 'md-invalid': !!errors.entity_type }" class="entity-type-container">
                            <span>{{ entityTypeSelectionLabel }} : *</span>
                            <entity-type-input
                                dusk="entity-type-input"
                                v-model="fData.entity_type"
                            />
                            <span v-if="errors.entity_type" class="md-error">{{
                                errors.entity_type ? errors.entity_type[0] : ""
                            }}</span>
                        </div>
                        <!--
                        <div class="pilot-owner-links">
                            <a href="/registration-other/pilot">{{ $t("registration.you-are-pilot") }}</a>
                            <a href="/registration-other/owner">{{ $t("registration.you-are-owner") }}</a>
                        </div>
                        !-->
                        <div class="form-row" v-if="fData.entity_type == 'company'">
                            <md-field :class="{ 'md-invalid': !!errors.entity_name }">
                                <label>{{ $t("registration.entity-name") }}</label>
                                <md-input
                                    type="text"
                                    name="entity_name"
                                    v-model="fData.entity_name"
                                    :disabled="submitting ? 'disabled' : null"
                                    dusk="entity-name-input"
                                    required
                                />
                                <span
                                    class="md-error"
                                    v-html="
                                        errors.entity_name ? errors.entity_name[0] : ''
                                    "
                                />
                            </md-field>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <md-field :class="{ 'md-invalid': !!errors.lastname }">
                                    <label>{{ $t("registration.lastname") }}</label>
                                    <md-input
                                        name="lastname"
                                        v-model="fData.lastname"
                                        :disabled="submitting ? 'disabled' : null"
                                        required
                                    />
                                    <span class="md-error">{{
                                        errors.lastname ? errors.lastname[0] : ""
                                    }}</span>
                                </md-field>
                            </div>
                            <div class="col">
                                <md-field :class="{ 'md-invalid': !!errors.firstname }">
                                    <label>{{ $t("registration.firstname") }}</label>
                                    <md-input
                                        name="firstname"
                                        v-model="fData.firstname"
                                        :disabled="submitting ? 'disabled' : null"
                                        required
                                    />
                                    <span class="md-error">{{
                                        errors.firstname ? errors.firstname[0] : ""
                                    }}</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="form-row">
                            <city-input
                                no-icon
                                name="city_id"
                                :label="$t('registration.your-city')"
                                :no-label="true"
                                v-model="fData['city_id']"
                                :city-name="fData['city_name']"
                                :input-error="errors['city_id']"
                                :disabled="submitting ? 'disabled' : null"
                                dusk="city-input"
                                required
                            />
                        </div>

                        <div class="form-row" :class="{ 'mt-35': !!errors.mobile }">
                            <phone-field
                                name="phone"
                                v-model="fData.mobile"
                                :errors="errors.mobile"
                                :label="$t('registration.mobile')"
                                mobile-only
                                :country-id="countryId"
                                ref="phoneInput"
                                :disabled="submitting ? 'disabled' : null"
                                required
                            />
                        </div>

                        <div class="form-row" v-if="showEmailField">
                            <md-field :class="{ 'md-invalid': !!errors.email }">
                                <label>{{ $t("registration.your-email") }}</label>
                                <md-input
                                    type="email"
                                    name="email"
                                    v-model="fData.email"
                                    :disabled="submitting ? 'disabled' : null"
                                    dusk="email-input"
                                    required
                                />
                                <span
                                    class="md-error"
                                    v-html="errors.email ? errors.email[0] : ''"
                                />
                            </md-field>
                        </div>

                        <div class="form-row">
                            <md-field :class="{ 'md-invalid': !!errors.password }">
                                <label>{{ $t("registration.password") }}</label>
                                <md-input
                                    type="password"
                                    name="password"
                                    v-model="fData.password"
                                    :disabled="submitting ? 'disabled' : null"
                                    @focus="
                                        passwordFieldFocused = true;
                                        passwordFieldTouched = true;
                                    "
                                    @blur="passwordFieldFocused = false"
                                    required
                                />
                                <span class="md-error">{{
                                    errors.password ? errors.password[0] : ""
                                }}</span>
                            </md-field>
                        </div>
                        <div class="form-row form-row-submit">
                            <div class="form-submit-button">
                                <p class="accept-tos" v-html="$t('registration.accept-tos')"></p>
                                <submit-button
                                    type="submit"
                                    class="registration-standalone-button"
                                    :submitting="submitting"
                                    :label="$t('registration.confirm-email.button')"
                                    @click="onSubmit()"
                                    dusk="submit-profile-button"
                                />
                            </div>
                        </div>
                        <div class="form-row form-row-already-member">
                            <a href="/member">{{ $t('registration.already-member-log-in') }}</a>
                        </div>
                    </div>
                </transition>
            </md-card-content>
        </md-card>
    </form>
</template>

<script>
import PhoneField from "../../widgets/PhoneFieldComponent.vue";
import CityInput from "../../widgets/CityInputComponent.vue";
import EntityTypeInput from "../../widgets/EntityTypeInput.vue";

export default {
    components: { PhoneField, CityInput, EntityTypeInput },
    props: {
        action: {
            type: String,
            required: true,
        },
        formString: {
            type: String,
            required: true,
        },
        fromAirportId: {
            type: String,
            default: "",
        },
        toAirportId: {
            type: String,
            default: "",
        },
        countryId: {
            type: String,
        },
        entityRolesString: {
            type: String,
        },
        templateString: {
            type: String,
        },
        introPhrase: {
            type: String,
            default: "fill-profile-freemium",
        },
        // displayLegalStatusField: {
        //     type   : Boolean,
        //     default: true,
        // },
        showEmailField: {
            type: Boolean,
            default: false,
        },
        entityTypesString: {
            type: String,
            required: true,
        },
        userRolesString: {
            type: String,
            required: true,
        },
        registrationPageId: String,
        displayFormProp: {
            type: Boolean,
            default: false
        },
        hideEntityType: {
            type: Boolean,
            default: false,
        },
        findWayString:{
            type: String,
            required: true,
        },
        userNeedsString:{
            type: String,
            required: true,
        }
    },
    data() {
        return {
            fData: {
                lastname: "",
                firstname: "",
                email: "",
                mobile: "",
                password: "",
                airport_id: null,
                city_id: null,
                accept_mail: 1,
                // legal_status         : null,
                entity_type: null,
                entity_name: null
            },
            errors: {
                lastname: null,
                firstname: null,
                email: null,
                mobile: null,
                password: null,
                airport_id: null,
                city_id: null,
                accept_mail: null,
                // legal_status         : null,
                entity_type: null,
                entity_name: null
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
        };
    },
    computed: {
        form() {
            return this.parseProp(this.formString);
        },
        template() {
            return this.parseProp(this.templateString) || {};
        },
        title() {
            if (
                !this.template.form_title ||
                !this.template.form_title[this.$i18n.locale()]
            ) {
                return this.$t("registration." + this.introPhrase);
            }

            return this.template.form_title[this.$i18n.locale()];
        },
        entityTypes() {
            return this.parseProp(this.entityTypesString);
        },
        userRoles() {
            return this.parseProp(this.userRolesString);
        },
        entityTypeSelectionLabel() {
            if(
                !this.template.entity_type_selection_label ||
                !this.template.entity_type_selection_label[this.$i18n.locale()]
            ) {
                return this.$t('registration.flight-as-label');
            }
            return this.template.entity_type_selection_label[this.$i18n.locale()];
        },
        findWay() {
            return this.parseProp(this.findWayString);
        },
        userNeeds() {
            return this.parseProp(this.userNeedsString);
        }
    },
    mounted() {
        this.setupForm();
        if (this.hideEntityType) {
            this.fData.entity_type = 'company';
        }
    },
    methods: {
        parseProp(prop) {
            if (!prop) {
                return;
            }

            return JSON.parse(prop);
        },
        setupForm() {
            if (!this.form) {
                return;
            }

            for (let i of Object.keys(this.form)) {
                this.fData[i] = this.form[i];
            }

            if (this.fromAirportId) {
                this.fData.airport_id = this.fromAirportId;
            }
            if (this.toAirportId) {
                this.fData.destination_airport_id = this.toAirportId;
            }
        },
        onSubmit() {
            this.submitting = true;

            for (let i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }

            axios
                .post(this.action, {
                    ...this.fData,
                    registration_page_id: this.registrationPageId,
                    simple: true,
                })
                .then(({ data }) => {
                    if (data.status === "ok") {
                        window.location = data.redirect;
                    }

                    this.submitting = false;
                })
                .catch(
                    ({
                        response: {
                            data: { errors },
                        },
                    }) => {
                        this.submitting = false;

                        for (let i of Object.keys(this.errors)) {
                            this.errors[i] = errors[i];
                        }
                    }
                );
        },
    },
};
</script>

<style lang="scss" scoped>
.text-grey-light {
    color: rgba(0, 0, 0, 0.54);
}
</style>
<style lang="scss">
@import "~styles/_variables";

.registration-form {
    height: fit-content;
    .md-title {
        div {
            font-weight: 600;
            font-size: 18px;
            text-align: center;
        }
    }
    .md-error {
        color: #ff1744;
        opacity: 1;
        transform: translateZ(0);
    }
    .pilot-owner-links {
        display: flex;
        flex-direction: column;
        margin: 10px 6px;
        a {
            font-size: 13px;
            text-decoration: underline;
            font-weight: 500;
            line-height: 26px;
        }
    }
    .entity-type-container {
        display: flex;
        flex-direction: column;
        width: auto;
        margin-left: 5px;
        margin-right: 5px;
        span {
            font-size: 16px;
            font-weight: 600;
            color: $primary-color-dark;
        }
        span.md-error {
            color: var(--md-theme-default-fieldvariant, #ff1744);
            height: 20px;
            font-size: 12px;
            transition: .3s cubic-bezier(.4,0,.2,1);
            font-weight: normal;
        }
        .entity-type-input {
            //  justify-content: space-around;
            button {
                margin: 10px 15px;
            }
        }
        @media (max-width: $mobile-top-breakpoint) {
            margin-top:30px;
        }
        @media (min-width: $desktop-bottom-breakpoint) {
            .entity-type-input {
                justify-content: flex-start;
                button {
                    margin-left:0px;
                }
            }
        }
    }
    .md-invalid {
        margin-bottom: 50px;
    }
    .form-row-submit {
        margin-top: 0px;

        .accept-tos {
            width: 100%;
            margin-top: 0px;
            margin-bottom: 10px;
        }
        button {
            padding: 10px 20px;
            font-size: 100%;
        }
    }

    // .form-row.is-legal-status {
    //     margin-left: 5px;
    //     margin-right: 5px;
    //     margin-bottom: 1em;
    //     display: flex;
    //     flex-direction: column;

    //     .legal-status-label {
    //         width: fit-content;
    //         margin-top: .2em;
    //         margin-bottom: -.2em;
    //         font-size: 16px;
    //         line-height: 20px;
    //         color: rgba(0, 0, 0, 0.54);
    //         transition: .4s cubic-bezier(.25, .8, .25, 1);
    //         transition-duration: .3s;
    //         position: relative;

    //         &:after {
    //             content: '*';
    //             top: 2px;
    //             right: 0;
    //             line-height: 1em;
    //             vertical-align: top;
    //             transform: translateX(calc(100% + 2px));
    //             position: absolute;
    //         }
    //     }

    //     .legal-status-fields {
    //         display: flex;
    //         flex-wrap: wrap;
    //     }

    //     .md-invalid,
    //     .md-error {
    //         color: #ff1744;
    //         color: var(--md-theme-default-fieldvariant, #ff1744);
    //     }
    //     .md-error {
    //         margin-top: -.7em;
    //         font-size: 12px;
    //     }

    //     .md-radio:first-of-type {
    //         margin-right: 2em;
    //         margin-bottom: 0;
    //     }
    //     .md-radio-label {
    //         font-size: 16px;
    //         color: rgba(0, 0, 0, 0.54);
    //         position: static;
    //     }
    // }

    .password-rules {
        font-size: 12px;
    }
    @media (max-width: $mobile-top-breakpoint) {
        margin-bottom: 30px;
    }

    .form-row-already-member {
        text-align: center;
        margin-top: 10px;
        a {
            color: $primary-color-dark;
            text-decoration: underline;
            font-size: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/formSimple.vue